function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.68 13.83a.556.556 0 010-.821L10.01 8 4.68 2.991a.556.556 0 010-.82.646.646 0 01.873 0l5.765 5.418c.116.11.181.257.181.411a.564.564 0 01-.18.41l-5.766 5.42a.646.646 0 01-.873 0z",
  fill: "#2D2D2D"
});
function SvgChevronderecha(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Chevron derecha.svg";
export { SvgChevronderecha as ReactComponent };